import React from 'react';
import PropTypes from 'prop-types';

export const SearchBoxNoResults = ({ message }) => (
  <ul>
    <li className="dropdown__item dropdown__item--no-results">{message}</li>
  </ul>
);

SearchBoxNoResults.propTypes = {
  message: PropTypes.string.isRequired,
};
